/**
 * @author Jonathan Almanza
 * 21/11/2018
 */
export enum LoginFormState {
  LOGIN = 'LOGIN',
  FORGOTTEN = 'FORGOTTEN',
  REGISTRATION = 'REGISTRATION'
}
